module.exports = __webpack_public_path__ + "img/lirun.96f41602.png";